module.exports = __webpack_public_path__ + "static/img/series_1_couse_1_cover.ecf6194.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/_course/series_1_couse_1_cover.jpg
// module id = 14D7
// module chunks = 0